module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/textbooks-c313be00947d130acc65bacb068c677c.svg";